/* ============================================
   CHADDORS PREMIUM ANIMATIONS v2
   Safe — no auto-hiding of content
   ============================================ */
(function() {
  'use strict';

  /* -- Scroll Progress Bar -- */
  var progressBar = document.createElement('div');
  progressBar.className = 'scroll-progress';
  document.body.prepend(progressBar);

  window.addEventListener('scroll', function() {
    var scrolled = window.scrollY;
    var total = document.documentElement.scrollHeight - window.innerHeight;
    if (total > 0) {
      progressBar.style.transform = 'scaleX(' + (scrolled / total) + ')';
    }
  }, { passive: true });

  /* -- Parallax for Hero Banners -- */
  var bannerImages = document.querySelectorAll('.banner__media img, .banner__media video');
  if (bannerImages.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          bannerImages.forEach(function(el) {
            var banner = el.closest('.banner');
            if (!banner) return;
            var rect = banner.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
              var progress = rect.top / window.innerHeight;
              el.style.transform = 'translateY(' + (progress * 20) + 'px) scale(1.03)';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* -- Sticky Header Blur on Scroll -- */
  var headerSection = document.querySelector('.section-header');
  if (headerSection) {
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:100%;pointer-events:none;';
    document.body.prepend(sentinel);

    var headerObserver = new IntersectionObserver(
      function(entries) {
        headerSection.classList.toggle('scrolled', !entries[0].isIntersecting);
      },
      { threshold: 1, rootMargin: '-1px 0px 0px 0px' }
    );
    headerObserver.observe(sentinel);
  }
})();
